module.exports = __webpack_public_path__ + "media/images/thumbs/biology/m_animation_phagocytes_9-64a26314ace6da854b635fbe98955007.jpg";